import { HTTPError } from 'ky';
import { z } from 'zod';

import type { ClientCategorisation } from '@/constants';
import { BINARY_ANSWERS } from '@/constants/answers';
import i18n from '@/lib/i18n';
import { fastApi } from '@/services/api';

const PATH = 'v1/customer/form/client-categorisation';

export const clientCategorisationAnswersSchema = z.object({
  hasRelevantDerivativesTradingFrequency: z.enum(BINARY_ANSWERS, { error: i18n.t('requiredField.error') }),
  hasRelevantPortfolioValue: z.enum(BINARY_ANSWERS, { error: i18n.t('requiredField.error') }),
  hasRelevantTradingExperience: z.enum(BINARY_ANSWERS, { error: i18n.t('requiredField.error') }),
});

export type ClientCategorisationAnswers = z.infer<typeof clientCategorisationAnswersSchema>;

export const clientCategorisationQuestionnaireSchema = z.object({
  answers: clientCategorisationAnswersSchema,
});

export type ClientCategorisationQuestionnaire = z.infer<typeof clientCategorisationQuestionnaireSchema>;

type ClientCategorisationQuestionnaireGetResponse = ClientCategorisationQuestionnaire & {
  /** Categorisation derived by the API from the answers. */
  c: ClientCategorisation;
  d: string;
};

export const getClientCategorisationQuestionnaire = async () => {
  return fastApi
    .get(PATH)
    .json<ClientCategorisationQuestionnaireGetResponse>()
    .catch((error) => {
      if (error instanceof HTTPError && error.response.status === 404) return null;

      throw error;
    });
};

export type ClientCategorisationQuestionnairePostRequestBody = ClientCategorisationQuestionnaire;

export const postClientCategorisationQuestionnaire = async (body: ClientCategorisationQuestionnairePostRequestBody) => {
  await fastApi.post(PATH, { json: body });
};
